import { useFetch } from "@hooks/useFetch";
import { getDeviceDetailsApiRoute } from "@api-routes/eirSalesFacade";
import { useEffect, useState } from "react";
import { getPostDeviceDetailsPayload, IDeviceDetailsResponse } from "@features/cart/interfaces/IDeviceDetails";
import { IESimDeviceForm } from "@features/cart/interfaces/IESimDeviceForm";

interface IParams {
    offerId: number;
    isESimFormOpen: boolean;
}

export const useGetDeviceDetails = (props: IParams) => {
    const { offerId, isESimFormOpen } = props;

    const [getDeviceDetailsState, { get }] = useFetch();
    const [postDeviceDetailsState, { post }] = useFetch();
    const [deleteDeviceDetailsState, { deleteCall }] = useFetch();

    const [deviceDetails, setDeviceDetails] = useState<IDeviceDetailsResponse>();

    useEffect(() => {
        if (!isESimFormOpen) {
            return;
        }

        get<IDeviceDetailsResponse | boolean>(getDeviceDetailsApiRoute(offerId)).then((deviceDetailsResponse) => {
            if (typeof deviceDetailsResponse !== "boolean" && deviceDetailsResponse) {
                setDeviceDetails(deviceDetailsResponse);
            }
        });
    }, [get, offerId, isESimFormOpen]);

    const postDeviceDetails = async (deviceOfferId: number, form: IESimDeviceForm) => {
        const response = await post<IDeviceDetailsResponse>(getDeviceDetailsApiRoute(deviceOfferId), {
            body: getPostDeviceDetailsPayload(form.eid, form.brand),
        });
        if (response) {
            setDeviceDetails(response);
        }
    };

    const deleteDeviceDetails = async (deviceOfferId: number) => {
        const response = await deleteCall(getDeviceDetailsApiRoute(deviceOfferId));
        if (response) {
            setDeviceDetails(undefined);
        }
    };

    return {
        deviceDetails,
        getDeviceDetailsState,
        deleteDeviceDetails,
        deleteDeviceDetailsState,
        postDeviceDetails,
        postDeviceDetailsState,
    };
};
